import { Link } from 'react-router-dom';
import type { JSX } from 'react';

export default function CardHeader({ text, icon, redirectUrl }: { text: string; icon: JSX.Element | undefined, redirectUrl?: string }) {
  return (
    redirectUrl
      ? (
        <div className="p-2">
          <Link className="group flex justify-between items-start text-base text-wrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-pipblue rounded" to={redirectUrl}>
            <span
              title={text}
              className="text-base text-wrap group-hover:underline group-focus:underline group-hover:text-primary group-focus:text-primary"
            >
              {text}
            </span>
            <span className="text-xl group-hover:text-primary group-focus:text-primary group-hover:scale-110 group-focus:scale-110 transition-transform">{icon}</span>
          </Link>
        </div>
      )
      : (
        <div className="p-2 flex justify-between items-start">
          <span title={text} className="text-base text-wrap ">{text}</span>
          <span className="text-xl">{icon}</span>
        </div>
      )
  );
}
